exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customize-categoryexplorer-component{padding-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/customize/categoryexplorer.scss
// module id = 1010
// module chunks = 0